import { MsalGuardConfiguration } from "@azure/msal-angular";
import { AppConfigService } from "../services/app-config.service";
import { InteractionType } from "@azure/msal-browser";

/**
 * Factory function that creates an instance of `MsalGuardConfiguration`.
 * 
 * @param appConfigService - The `AppConfigService` instance used to retrieve the configuration values.
 * @returns An instance of `MsalGuardConfiguration` with the specified configuration values.
 */
export function MSALGuardConfigFactory(appConfigService: AppConfigService): MsalGuardConfiguration {
    return {
        interactionType: appConfigService.get().msal.guard.interactionType as InteractionType.Redirect | InteractionType.Popup,
        authRequest: appConfigService.get().msal.guard.authRequest
    };
}